import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getNewsroomNews } from 'b2b-apps/shop/content/redux/newsroom/selectors';
import { NewsroomNewsType } from 'b2b-common/core/content/api/Newsroom.types';

export type UseNewsroomNewsDataReturnType = RemoteRecord<NewsroomNewsType>;

export function useNewsroomNewsData(): UseNewsroomNewsDataReturnType {
  return useSelector(getNewsroomNews);
}
